import { COPY_MEDIA } from '../../constants';

const initialState = {
  data: {},
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case COPY_MEDIA.LOAD:
      return {
        ...state,
        loading: true,
      };
    case COPY_MEDIA.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case COPY_MEDIA.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
